module.exports = __webpack_public_path__ + "static/steamButton-acb0bf78ef2520b3f72ed35b03d9e495.png";